import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { BrowserRouter as Router } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));
const pca = new PublicClientApplication(msalConfig);

// Global safety net: capture unhandled promise rejections and runtime errors
// to avoid noisy "Uncaught (in promise)" logs and provide clearer diagnostics.
if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', (event) => {
        try {
            // Prevent default browser noise and log a concise message
            if (event && typeof event.preventDefault === 'function') event.preventDefault();
        } catch {}
        // Prefer reason.body (from our fetch helpers) else message/stack
        const r = event?.reason;
        const msg = (r && (r.body || r.message)) || String(r || 'Unhandled promise rejection');
        // eslint-disable-next-line no-console
        console.error('[Global] Unhandled promise rejection:', msg);
    });
    window.addEventListener('error', (event) => {
        // eslint-disable-next-line no-console
        console.error('[Global] Runtime error:', event?.message || event?.error || 'Unknown error');
    });
}

root.render(
    <MsalProvider instance={pca}>
        <Router>
            <App />
        </Router>
    </MsalProvider>
);

